import { Directive, Input, OnInit, ElementRef, Renderer2, HostListener } from '@angular/core';

@Directive({
  selector: '[popover]'
})
export class PopoverDirective implements OnInit {

  private _show:boolean = false;

  @Input() set popover(value: string) {
      this.contentString = value;
  }

  @Input() set show(value: boolean) {
      this._show = value;
      this.setDisplay();
  }

  private pop:HTMLElement;
  private moveHandler:any;
  private enterHandler:any;
  private leaveHandler:any;
  private contentString:string = '';

  constructor(private el: ElementRef,private renderer: Renderer2) {}

  ngOnInit(): void {

    this.moveHandler = this.mousemove.bind(this);
    this.enterHandler = this.onMouseEnter.bind(this);
    this.leaveHandler = this.onMouseLeave.bind(this);

    // create popover if it doesn't already exist

    const tmpParent = this.el.nativeElement.ownerDocument.body;
    let tmpPop = tmpParent.querySelector('.popover');

    if(tmpPop){
      this.pop = tmpPop;
    }else{
      this.pop = document.createElement('div');

      const content = document.createElement('div');
      // title.innerHTML = this.maskedText;
      content.innerHTML = this.contentString;

      this.pop.appendChild(content);
      this.renderer.appendChild(tmpParent, this.pop);

      this.renderer.addClass(this.pop, 'popover');
      this.renderer.addClass(content, 'popover-content');

    }

    this.setDisplay();
  }

  setDisplay():void{
    if(this._show){
      this.el.nativeElement.addEventListener('mouseenter',this.enterHandler);
      this.el.nativeElement.addEventListener('mouseleave',this.leaveHandler);
    }else{
      this.el.nativeElement.removeEventListener('mouseenter',this.enterHandler);
      this.el.nativeElement.removeEventListener('mouseleave',this.leaveHandler);
    }
  }

  mousemove(event) {
     const padding = 30;
     //event.preventDefault();
     let top:number = event.clientY;
     let left:number = event.clientX;

     // if it's past the bottom move it up
     if(top + this.pop.clientHeight + padding > event.view.innerHeight)
      top = event.view.innerHeight - this.pop.clientHeight - padding;

     this.positionPop(left,top);
   }

   onMouseEnter(event) {
      event.preventDefault();
      // set content
      this.pop.querySelector('.popover-content').innerHTML = this.contentString;
      this.renderer.addClass(this.pop, 'shown');
      document.addEventListener('mousemove',this.moveHandler,false);
  }

  onMouseLeave(event) {
     event.preventDefault();
     this.destroy();
  }

  positionPop(x:number,y:number):void{

    this.pop.style.top = `${y+20}px`;
    this.pop.style.left = `${x+20}px`;
  }

  destroy(): void {
    this.renderer.removeClass(this.pop, 'shown');
    document.removeEventListener('mousemove',this.moveHandler,false);

  }

  ngOnDestroy(): void {
    this.el.nativeElement.removeEventListener('mouseenter',this.enterHandler);
    this.el.nativeElement.removeEventListener('mouseleave',this.leaveHandler);
    this.destroy();
  }


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/directives/popover.directive.ts